// Calculate Age from Date of Birth String
export const calculateAge = (dobString) => {
    if (!dobString) return '---';
    try {
        const [month, day, year] = dobString.split('/').map(Number);
        const birthDate = new Date(year, month - 1, day); 
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
        return isNaN(age) ? '---' : age;
    } catch (e) {
        return '---';
    }
};

// Map talent names to specific emojis dynamically
export const getSkillIcon = (skillName) => {
    if (!skillName) return '⭐';
    const name = skillName.toLowerCase().trim();
    if (name.includes('acting') || name.includes('actor') || name.includes('actress')) return '🎭';
    if (name.includes('dance') || name.includes('dancing') || name.includes('dancer')) return '💃';
    if (name.includes('sing') || name.includes('singing') || name.includes('singer')) return '🎤';
    if (name.includes('voice over') || name.includes('voiceover') || name.includes('voice-over') || name.includes('dubbing')) return '🎙️';
    if (name.includes('swim') || name.includes('swimming')) return '🏊';
    if (name.includes('horse') || name.includes('riding')) return '🏇';
    if (name.includes('yoga')) return '🧘';
    if (name.includes('drive') || name.includes('driving')) return '🚗';
    if (name.includes('gym') || name.includes('fitness') || name.includes('workout')) return '🏋️';
    if (name.includes('cricket')) return '🏏';
    if (name.includes('badminton')) return '🏸';
    if (name.includes('cook') || name.includes('cooking') || name.includes('chef')) return '🍳';
    return '⭐';
};

// Deterministic AI Score Calculator based on real profile completeness
export const calculateAIScores = (tp) => {
    const talentsCount = tp.talent ? tp.talent.split(',').length : 0;
    const hasBio = tp.aboutYourself && tp.aboutYourself.length > 10;
    const bioLength = tp.aboutYourself ? tp.aboutYourself.length : 0;
    const experiencesCount = Array.isArray(tp.experiences) ? tp.experiences.length : 0;
    const educationsCount = Array.isArray(tp.educations) ? tp.educations.length : 0;
    const languagesCount = tp.languages ? tp.languages.split(',').length : 1;
    const hasImage = !!tp.profileImage || !!tp.profile_image_url;

    let emotion = 74;
    if (tp.talent && tp.talent.toLowerCase().includes('acting')) emotion += 6;
    emotion += Math.min(educationsCount * 4, 12);
    
    let voice = 72;
    if (tp.talent && (tp.talent.toLowerCase().includes('sing') || tp.talent.toLowerCase().includes('voice'))) voice += 8;
    voice += Math.min(languagesCount * 3, 12);

    let dialogue = 70;
    if (hasBio) dialogue += Math.min(Math.floor(bioLength / 50) * 2, 10);
    dialogue += Math.min(languagesCount * 2, 8);
    dialogue += Math.min(educationsCount * 3, 9);

    let confidence = 68;
    if (hasBio) confidence += Math.min(Math.floor(bioLength / 40) * 2, 12);
    confidence += Math.min(experiencesCount * 4, 16);

    let body = 74;
    if (tp.height_cm || tp.height) body += 6;
    body += Math.min(experiencesCount * 3, 15);

    let camera = 65;
    if (hasImage) camera += 15;
    camera += Math.min(experiencesCount * 4, 16);

    let pace = 72;
    pace += Math.min(experiencesCount * 3, 12);
    pace += Math.min(educationsCount * 4, 12);

    let versatility = 60;
    versatility += Math.min(talentsCount * 6, 24);
    versatility += Math.min(languagesCount * 4, 12);

    const cap = (score) => Math.min(Math.max(score, 50), 98);

    const emotionFinal = cap(emotion);
    const voiceFinal = cap(voice);
    const dialogueFinal = cap(dialogue);
    const confidenceFinal = cap(confidence);
    const bodyFinal = cap(body);
    const cameraFinal = cap(camera);
    const paceFinal = cap(pace);
    const versatilityFinal = cap(versatility);

    const overall = Math.round(
        (emotionFinal + voiceFinal + dialogueFinal + confidenceFinal + bodyFinal + cameraFinal + paceFinal + versatilityFinal) / 8
    );

    let performanceLabel = "Rising Performer";
    if (overall >= 90) performanceLabel = "Excellent Performer";
    else if (overall >= 80) performanceLabel = "Great Performer";
    else if (overall >= 70) performanceLabel = "Good Performer";

    return {
        emotion: emotionFinal,
        voice: voiceFinal,
        dialogue: dialogueFinal,
        confidence: confidenceFinal,
        body: bodyFinal,
        camera: cameraFinal,
        pace: paceFinal,
        versatility: versatilityFinal,
        overall,
        label: performanceLabel
    };
};